export type TourRole = 'ALL' | 'EDITOR_ADMIN' | 'ADMIN';

export interface TourStep {
  id: string;
  title: string;
  body: string;
  tourId: string | null;
  route: string | null;
  settingsTab?: string;
  role: TourRole;
  openInitiativeModal?: boolean;
  openUserMenu?: boolean;   // programmatically open the user dropdown before finding element
  preferLeft?: boolean;     // position tooltip to the left of the target element
}

export const ALL_STEPS: TourStep[] = [
  {
    id: 'welcome',
    title: 'Welcome to your workspace!',
    body: 'Take a quick tour to discover what you can do here.',
    tourId: null,
    route: null,
    role: 'ALL',
  },
  {
    id: 'dashboard',
    title: 'Your Dashboard',
    body: 'See roadmap stats, initiative breakdown, and recent activity — all at a glance.',
    tourId: 'dashboard-heading',
    route: '/home',
    role: 'ALL',
  },
  {
    id: 'timeline',
    title: 'Timeline View',
    body: 'Visualize your initiatives across timeframes on a horizontal roadmap.',
    tourId: 'timeline-content',
    route: '/timeline',
    role: 'ALL',
  },
  {
    id: 'add-initiative',
    title: 'Add an Initiative',
    body: 'Click here to create an initiative. Customize field labels and visibility in Settings.',
    tourId: 'add-initiative-btn',
    route: null,
    role: 'EDITOR_ADMIN',
  },
  {
    id: 'intelligence',
    title: 'Initiative Intelligence',
    body: 'Click the Intelligence tab inside any initiative for AI-powered health analysis, risk detection, PM suggestions, and user stories — powered by Claude.',
    tourId: 'initiative-intelligence-tab',
    route: null,
    role: 'ALL',
    openInitiativeModal: true,
  },
  {
    id: 'list',
    title: 'List View',
    body: 'Filter and sort all your initiatives in a compact table view.',
    tourId: 'list-content',
    route: '/list',
    role: 'ALL',
  },
  {
    id: 'ai-credits',
    title: 'AI Credits',
    body: 'Buy AI credits or earn free credits by referring others. Access billing and AI settings from your profile menu.',
    tourId: 'refer-earn-btn',
    route: null,
    role: 'ALL',
    openUserMenu: true,
    preferLeft: true,
  },
  {
    id: 'settings-hierarchy',
    title: 'Customize Your Hierarchy',
    body: "Rename Products, Sub-products, and Initiatives to match your org's language. Start here.",
    tourId: 'settings-hierarchy-tab',
    route: '/settings',
    settingsTab: 'hierarchy',
    role: 'ADMIN',
  },
  {
    id: 'settings-users',
    title: 'Invite Your Team',
    body: 'Add teammates as Admins, Editors, or Viewers. Manage roles and pending invites here.',
    tourId: 'settings-users-tab',
    route: '/settings',
    settingsTab: 'users',
    role: 'ADMIN',
  },
];

export function buildSteps(role: string): TourStep[] {
  return ALL_STEPS.filter((step) => {
    if (step.role === 'ADMIN' && role !== 'ADMIN') return false;
    if (step.role === 'EDITOR_ADMIN' && role === 'VIEWER') return false;
    return true;
  });
}
